import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {}

const AlignEnd: React.FC<React.PropsWithChildren<Props>> = ({width = 16, height = 16, ...props}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15 14.816H1.184m9.499-5.181V2.727C10.683 1.773 9.909 1 8.956 1H7.229c-.954 0-1.727.773-1.727 1.727v6.908c0 .954.773 1.727 1.727 1.727h1.727c.953 0 1.727-.773 1.727-1.727z"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AlignEnd;
